import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from '../../axiosConfig';
import { useNavigate } from 'react-router-dom';
import '../../styles/ForgotPassword.css';

const ForgotPassword = () => {
    const { t } = useTranslation('auth');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        try {
            await axios.post('/api/v1/auth/reset-password-request', { email });
            setMessage(t('forgotPassword.successMessage'));
        } catch (err) {
            setError(t('forgotPassword.error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-box">
                <h1>{t('forgotPassword.title')}</h1>
                <p>{t('forgotPassword.subtitle')}</p>
                <form className="forgot-password-form" onSubmit={handleSubmit}>
                    <input
                        type="email"
                        name="email"
                        placeholder={t('forgotPassword.emailPlaceholder')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    {message && <p className="forgot-password-success">{message}</p>}
                    {error && <p className="forgot-password-error">{error}</p>}
                    <button type="submit" className="submit-button" disabled={loading}>
                        {loading ? t('forgotPassword.sending') : t('forgotPassword.sendButton')}
                    </button>
                    <button type="button" className="back-button" onClick={() => navigate('/')}>
                        {t('forgotPassword.backToLogin')}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
